/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerCustomerDemoModule
 * Purpose		: Module for CustomerCustomerDemo.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { CustomerCustomerDemoService } from './CustomerCustomerDemo.service';
import { CustomerCustomerDemoListComponent } from './CustomerCustomerDemoList.component';
import { CustomerCustomerDemoSearchComponent } from './CustomerCustomerDemoSearch.component';
import { CustomerCustomerDemoAddComponent } from './CustomerCustomerDemoAdd.component';
import { CustomerCustomerDemoEditComponent } from './CustomerCustomerDemoEdit.component';
import { CustomerCustomerDemoDetailsComponent } from './CustomerCustomerDemoDetails.component';

import { CustomerCustomerDemoRoutingModule } from './CustomerCustomerDemo-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    CustomerCustomerDemoRoutingModule
  ],
  declarations: [
    CustomerCustomerDemoListComponent,
	CustomerCustomerDemoSearchComponent,
    CustomerCustomerDemoEditComponent,
    CustomerCustomerDemoAddComponent,
	CustomerCustomerDemoDetailsComponent
  ],
  providers: [
    CustomerCustomerDemoService
  ]
})

export class CustomerCustomerDemoModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerCustomerDemo/CustomerCustomerDemo.module.ts